// extracted by mini-css-extract-plugin
export var attribution = "_bm-4";
export var authorName = "_bm-5";
export var quote = "_bm-3";
export var testimonial = "_bm-2";
export var trustedBy = "_bm-0";
export var trustedByLabel = "_bm-1";